// ABOUTME: Placeholder view for errors/notifications management.
// ABOUTME: Will contain the error and notification listing and CRUD functionality.

import { Box, useTheme } from "@mui/material";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../../theme";
import Subheading from "../../../../components/theme/text/Subheading";
import Text from "../../../../components/theme/text/Text";

const All = ({ settings = [], ...props }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    useEffect(() => {
        props.replaceView({
            ...props.config,
        });

        return () => {
        }
    }, []);

    return (
        <Box
            sx={{
                p: 3,
                display: "flex",
                flexDirection: "column",
                gap: 2,
            }}
        >
            <Subheading>{t("errors_notifications")}</Subheading>
            <Text light>{t("coming_soon")}</Text>
        </Box>
    );
};

export default All;
